import { useMemo } from 'react'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'
import { useGetMeQuery } from '../../../store/user/user'
import { getIntegrationServiceIdsForCategory, IntegrationCategory, type IntegrationServiceId } from '../../../common/integrations'

interface AccountOpeningConnectors {
  connectors: IntegrationServiceId[]
  hasAny: boolean
  isLoading: boolean
}

export const useAccountOpeningConnectors = (): AccountOpeningConnectors => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser, isLoading } = useGetMeQuery({ accountId })

  const connectors = useMemo(() => {
    const custodians = getIntegrationServiceIdsForCategory(IntegrationCategory.CUSTODIAN)
    const connected = new Set((currentUser?.integrations ?? []).map((integration) => integration.serviceId))
    return custodians.filter((serviceId) => connected.has(serviceId))
  }, [currentUser])

  return { connectors, hasAny: connectors.length > 0, isLoading }
}
